// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".u4hWQb9XcaenminCIij_{color:var(--text-neutral-secondary)}", "",{"version":3,"sources":["webpack://./src/aiTutor/views/aiTutorEnglishOnlyWarning.module.scss"],"names":[],"mappings":"AAAA,sBACE,mCAAA","sourcesContent":[".message {\n  color: var(--text-neutral-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": "u4hWQb9XcaenminCIij_"
};
export default ___CSS_LOADER_EXPORT___;
